export default "__VITE_ASSET__CEg7K2Lv__"